import { isCustomizationFeatureEnabled } from '../../handoff-metrics/handoff-metrics-helpers';
import {
  appointmentRemindersMetric,
  eyewearReminderMetric,
  inboundMessagesMetric,
  outboundMessagesMetric,
  recallReminderMetric,
  usersAddedMetric,
} from '../../handoff-metrics/metrics/software';
import { UnifyMetricDefinition, UnifyMetricEvalContext } from '../unify-metrics.types';
import { adaptHandoffMetric } from './adapt-handoff-metric';
import { VerticalEnum } from 'models/vertical-enum';

const shouldSkipSoftware = ({ officeConfigurations }: UnifyMetricEvalContext) =>
  Boolean(officeConfigurations?.isPhonesOnly);

export const manualMessagingMetricDef: UnifyMetricDefinition = {
  id: 'manual_messaging',
  name: 'Manual Messaging',
  sectionName: 'Software',
  allowExceptions: false,
  shouldSkip: shouldSkipSoftware,
  criteria: [
    adaptHandoffMetric(inboundMessagesMetric),
    adaptHandoffMetric(outboundMessagesMetric),
  ],
};

export const newUsersAddedMetricDef: UnifyMetricDefinition = {
  id: 'new_users_added',
  name: 'New Users Added',
  sectionName: 'Software',
  allowExceptions: true,
  shouldSkip: shouldSkipSoftware,
  criteria: [adaptHandoffMetric(usersAddedMetric)],
};

export const autoMessagingOnMetricDef: UnifyMetricDefinition = {
  id: 'auto_messaging_on',
  name: 'Auto Messaging On',
  sectionName: 'Software',
  allowExceptions: true,
  shouldSkip: (ctx) =>
    shouldSkipSoftware(ctx) ||
    !ctx.officeConfigurations?.isIntegrated ||
    !isCustomizationFeatureEnabled(
      'Online Schedule Appointment Writebacks',
      ctx.features
    ),
  criteria: [
    adaptHandoffMetric(recallReminderMetric),
    adaptHandoffMetric(appointmentRemindersMetric),
    adaptHandoffMetric(eyewearReminderMetric, {
      shouldSkip: (ctx) => ctx.verticalId !== VerticalEnum.Optometry,
    }),
  ],
};
